import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Typo from 'constants/typography'
import { getAssetPath } from 'lib/utils/common/commonUtils'
import { hasLocizeTranslation } from 'lib/utils/locize'
import styles from './style.scss'

const Franchise = ({ t }) => (
  <section className="franchise" aria-labelledby="franchise-title">
    <style jsx>{styles}</style>
    <img
      className="franchise__image"
      src={`${getAssetPath()}/static/img/pages/about-us/franchise.jpg`}
      alt=""
      width="1920"
      height="1080"
      loading="lazy"
    />
    <div className="franchise__content">
      <h2
        id="franchise-title"
        className={clsx('franchise__title', Typo.title2)}
      >
        {hasLocizeTranslation(
          t,
          'ABOUT_US_PAGE.FRANCHISE_TITLE',
          'Bring Pomelo to Your Market — Partner With One of Asia’s Fastest-Growing Fashion Brands',
        )}
      </h2>
      <p className={clsx('franchise__description', Typo.body1)}>
        {hasLocizeTranslation(
          t,
          'ABOUT_US_PAGE.FRANCHISE_DESCRIPTION',
          'If you have strong local market expertise and the ambition to build a long-term fashion business, we’d love to hear from you.',
        )}
      </p>
      <a
        className={clsx('franchise__cta', Typo.button)}
        href="mailto:franchise@pomelofashion.com"
      >
        {hasLocizeTranslation(t, 'ABOUT_US_PAGE.FRANCHISE_CTA', 'Get in Touch')}
      </a>
    </div>
  </section>
)

Franchise.propTypes = { t: PropTypes.func.isRequired }

export default Franchise
